import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MessageSquare } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function usePoll(fn, ms, enabled = true) {
  const ref = useRef(fn); ref.current = fn;
  useEffect(() => {
    if (!enabled) return;
    let t = null, stopped = false;
    const tick = async () => { if (stopped) return; if (document.visibilityState === "visible") { try { await ref.current(); } catch {} } t = setTimeout(tick, document.visibilityState === "visible" ? ms : ms * 5); };
    const onVis = () => { if (document.visibilityState === "visible") { clearTimeout(t); tick(); } };
    document.addEventListener("visibilitychange", onVis);
    t = setTimeout(tick, ms);
    return () => { stopped = true; clearTimeout(t); document.removeEventListener("visibilitychange", onVis); };
  }, [ms, enabled]);
}

export function useUnreadMessages() {
  const { user } = useAuth();
  const [n, setN] = useState(0);
  const load = () => api.get("/messages/unread").then(r => setN(r.data.total)).catch(() => {});
  useEffect(() => { if (user) load(); else setN(0); }, [user]);
  usePoll(load, 20000, !!user);
  return n;
}

export function MessageButton({ context_type, context_id, label = "Mensagem", className = "", testid }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!user) return nav("/login");
    setBusy(true);
    try { const { data } = await api.post("/messages/conversations", { context_type, context_id }); nav(`/mensagens/${data.id}`); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Não foi possível iniciar a conversa"); }
    finally { setBusy(false); }
  };
  return <button type="button" onClick={go} disabled={busy} data-testid={testid || `message-btn-${context_type}-${context_id}`} className={`inline-flex items-center justify-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-xl border border-zinc-300 hover:border-black transition-colors disabled:opacity-50 ${className}`}><MessageSquare size={13} /> {label}</button>;
}

export const fmtTime = (iso) => { const d = new Date(iso); const today = new Date().toDateString() === d.toDateString(); return today ? d.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" }) : d.toLocaleDateString("pt-PT", { day: "2-digit", month: "short" }); };

export function Linkify({ text }) {
  const parts = text.split(/(https?:\/\/[^\s]+)/g);
  return parts.map((p, i) => /^https?:\/\//.test(p) ? <a key={i} href={p} target="_blank" rel="noopener noreferrer nofollow" className="underline break-all">{p}</a> : <span key={i}>{p}</span>);
}
